export default __webpack_public_path__ + "static/media/icon_operation.8e169068.svg";